import { Button, Label, Layout, Panel, Switch } from "@mcleod/components";

export abstract class AutogenLayoutDemoScreenFlowSampleButtons extends Layout {
    buttonShowBasicSnackbar: Button;
    buttonShowCustomToast: Button;
    buttonShowDialog: Button;
    buttonShowDownloadSnackbar: Button;
    buttonShowOverlay: Button;
    buttonShowSlideoutBottom: Button;
    buttonShowSlideoutLeft: Button;
    buttonShowSlideoutRight: Button;
    buttonShowSlideoutTop: Button;
    buttonShowSuccessToast: Button;
    buttonShowWarningSnackbar: Button;
    labelDialogsTitle: Label;
    labelOverlayTitle: Label;
    labelSlideoutTitle: Label;
    labelSnackbarsTitle: Label;
    labelToastsTitle: Label;
    panelDialog: Panel;
    panelOverlay: Panel;
    panelSlideout: Panel;
    panelSnackbar: Panel;
    panelToast: Panel;
    switchDialogModal: Switch;
    switchDialogMovable: Switch;
    switchDialogResizable: Switch;
    switchSnackbarPersist: Switch;
    switchSnackbarTarget: Switch;
    switchToastPersist: Switch;
    switchToastTarget: Switch;
}
